// eslint-disable-next-line no-restricted-imports
import { Percent } from '@uniswap/sdk-core'
import { useWeb3React } from '@web3-react/core'
import { AutoColumn } from 'components/Column'
//import { L2_CHAIN_IDS } from 'constants/chains'
import { useOnClickOutside } from 'hooks/useOnClickOutside'
import { isSupportedChainId } from 'lib/hooks/routing/clientSideSmartOrderRouter'
import { useRef } from 'react'
import { useModalIsOpen, useToggleSettingsMenu } from 'state/application/hooks'
import { ApplicationModal } from 'state/application/reducer'
import styled from 'styled-components/macro'
import { Divider } from 'theme'
import { Z_INDEX } from 'theme/zIndex'

import LiquiditySourcesSettings from './LiquiditySourcesSettings'
import MaxSlippageSettings from './MaxSlippageSettings'
import MenuButton from './MenuButton'
import ReceiverSettings from './ReceiverSettings'
import RouterPreferenceSettings from './RouterPreferenceSettings'
//import TransactionDeadlineSettings from './TransactionDeadlineSettings'

const Menu = styled.div`
  position: relative;
`

const MenuFlyout = styled(AutoColumn)`
  min-width: 22rem;
  background-color: ${({ theme }) => theme.backgroundSurface};
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 6px;
  position: absolute;
  top: 100%;
  margin-top: 10px;
  right: 0;
  z-index: ${Z_INDEX.modal};
  color: ${({ theme }) => theme.textPrimary};
  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToSmall`
    min-width: 20rem;
  `};
  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToExtraSmall`
    min-width: 18rem;
    zoom:0.9;
    gap: 12px;
  `};
  user-select: none;
  gap: 16px;
  padding: 1.1rem;
`

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.backgroundScrolledSurface};
  z-index: ${Z_INDEX.modalBackdrop};
  pointer-events: auto;
`

export default function SettingsTab({
  autoSlippage,
  receiverEnabled = false,
  onToggleReceiver,
}: {
  autoSlippage: Percent
  receiverEnabled?: boolean
  onToggleReceiver?: () => void
}) {
  const { chainId } = useWeb3React()
  //const showDeadlineSettings = Boolean(chainId && !L2_CHAIN_IDS.includes(chainId))

  const node = useRef<HTMLDivElement | null>(null)
  const isOpen = useModalIsOpen(ApplicationModal.SETTINGS)

  const toggleMenu = useToggleSettingsMenu()
  useOnClickOutside(node, isOpen ? toggleMenu : undefined)

  const isSupportedChain = isSupportedChainId(chainId)

  return (
    <Menu ref={node}>
      <MenuButton disabled={!isSupportedChain} isActive={isOpen} onClick={toggleMenu} />
      {isOpen && (
        <>
          <Backdrop onClick={toggleMenu} />
          <MenuFlyout>
            <RouterPreferenceSettings />
            <Divider />
            <MaxSlippageSettings autoSlippage={autoSlippage} />
            <Divider />
            <LiquiditySourcesSettings />
            {onToggleReceiver && (
              <>
                <Divider />
                <ReceiverSettings enabled={receiverEnabled} onToggle={onToggleReceiver} />
              </>
            )}
            {/*showDeadlineSettings && (
            <>
              <Divider />
              <TransactionDeadlineSettings />
            </>
          )*/}
          </MenuFlyout>
        </>
      )}
    </Menu>
  )
}
